/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Wallet = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M21 12V7H5a2 2 0 0 1 0-4h14v4" }],
    ["path", { d: "M3 5v14a2 2 0 0 0 2 2h16v-5" }],
    ["path", { d: "M18 12a2 2 0 0 0 0 4h4v-4Z" }]
  ]
];

export { Wallet as default };
//# sourceMappingURL=wallet.js.map
